import { CATEGORY_SLUGS } from './curated-story-categories';

export const themes = [
  {
    categorySlug: CATEGORY_SLUGS.INNOVATORS_AND_VISIONARIES,
    name: 'mint-green',
  },
  {
    categorySlug: CATEGORY_SLUGS.CULTURE_AND_HERITAGE,
    name: 'peach',
  },
  {
    categorySlug: CATEGORY_SLUGS.SERVICE_AND_SACRIFICE,
    name: 'blue',
  },
  {
    categorySlug: CATEGORY_SLUGS.LABOR_AND_LIVELIHOOD,
    name: 'beige',
  },
  {
    categorySlug: CATEGORY_SLUGS.ICONS_AND_INFLUENCERS,
    name: 'purple',
  }
]
